import React from "react";
import { 
    Card, 
    Row, 
    Col, 
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
 } from "reactstrap";
import SectionData from './AuthorSection/SectionData'
import Select from 'react-select'
import SectionManage from './AuthorSection/SectionManage'
function getBreadcrums(breadc){ 
    let breadcrums = "";
    breadc.forEach(
        (breadcrum,index) => {
          `/ ${breadcrum} `;
          if(index === 0)
          {
              breadcrums = breadcrums + breadcrum;
          }
          else {
              breadcrums = breadcrums + ` / ` + breadcrum;
          }
        }
      );
return breadcrums;
}
export default class AuthorSection extends React.Component {
    
    state = {
        showModal: false,

    }

    // showDeleteSectionModal = () => {
    //     this.setState({showDeleteModal: !this.state.showDeleteModal})
    // }

    handleDeleteSection = () => {
        this.setState({showModal: false})
        console.log('section deleted successfully!!!')
    }

    showModal = (course, type, confirmAction) => {
      let modalText = "";
      let desc = "";
      // let modalAction;
      if (type === "delete") {
        modalText = `Attempting to delete ${course.name} (${
          course.displayName
        }). Are you sure you want to delete this ${course.displayName}? This action cannot be reversed. All data will be lost. (If you want to hide the course from users, click the "unpublish" icon.)`;
        desc = "Delete";
        // modalAction = this.deleteCourse;
      } else if (type === "publish") {
        if (course.published) {
          modalText = `Please confirm that you would like to UNPUBLISH ${
            course.name
          } (${
            course.displayName
          }). Once unpublished, the course can no longer be licensed to users, and any user who has an existing license to the course will not be able to access it. Unpublishing does not delete course data.`;
          desc = "Unpublish";
          // modalAction = this.togglePublish;
        } else {
          modalText = `Please confirm that you would like to publish ${
            course.name
          } (${
            course.displayName
          }). Once published, the course can be licensed to users, and will be accessible to licensed users.`;
          desc = "Publish";
          // modalAction = this.togglePublish;
        }
      } 
      if (type === 'parent') {
        modalText = "The ${record.name} ${record.collectionName} is currently in this ${record.parentCollectionName}: ${record.parentName}. Move ${record.name} to a different ${record.parentCollectionName}.' List of parents that can be selected. User must select a parent course. Defaults to the current setting. Move button and Cancel button. Move is disabled until a different parent is selected."
        desc = "Parent"
      }
      this.setState({
        showModal: true,
        modalText,
        desc,
        selectedSectionName: course.name,
        courseId: course.id,
        ...confirmAction
      });
    }
  
    getModal() {
      return (
        <Modal isOpen={this.state.showModal} className={this.state.desc === 'Delete' ? `modal-danger` : `modal-success`}>
          <ModalHeader style={this.state.desc !== 'Delete' ? { backgroundColor: '#1c2930' } : {}}>{this.state.desc} Section</ModalHeader>
          <ModalBody>
          {this.state.modalText}
          {this.state.desc === "Parent" ? 
          <div>
            <span style={{ color: '#375160' , fontSize: '17px' , fontWeight: 'bold' }}>
            Section:
            </span><Select /></div>
          
        : null}
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => this.state.confirmAction()} color="secondary">
              {this.state.desc === "Parent" ? "Move" : this.state.desc }
            </Button>
            <Button
              onClick={() => this.setState({ showModal: false })}
              color="secondary"
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      );
    }

    render() {

        let breadcrums = getBreadcrums([
            "ACT Mastery",
            "ACT Mastery English",
            "Challenger"
          ]);

        let section = {
          id: '12321',
          name: 'challenger',
          displayName: 'Challenger',
          published: true
        }  
        
        return (
        <Card className="course-edit-container">
        <span className='breadcrums'>{breadcrums}</span>
      <Row>
        <Col md='8' sm='8'>
          <h3 className="heading">Edit <span className="name">Challenger</span> Section <i onClick={() => 
            this.showModal(section ,'delete', {confirmAction: this.handleDeleteSection})} className='icon-delete-button'></i> </h3>
        </Col>
        <Col md='4' sm='4'>
          <Button style={{float: 'right', margin: '20px 0 20px 0'}} className='add-btn' size="sm">+ Create New Section</Button>
        </Col>
      </Row>
        
           {this.getModal()} 
      <Row>      
        <SectionData showModal={this.showModal} parentState={this.setState.bind(this)}/>
      </Row>

      <Row>
            <SectionManage />
      </Row>      
      </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorSection.js